import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService, IndividualConfig } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { environment as env } from 'src/environments/environment';

export interface AlertOptions {
  autoClose?: boolean;
  keepAfterRouteChange?: boolean;
  buttonRedirect?: boolean;
  componente?: string;
  arguments?: any;
  urlExterna?: any;
}

@Injectable({ providedIn: 'root' })
export class AlertService {

  private defaultOptions: Partial<IndividualConfig> = {
    timeOut: env.waitTimes.alerts,
    extendedTimeOut: env.waitTimes.alerts,
    closeButton: true,
    progressBar: true,
  };

  constructor(
    private toastr: ToastrService,
    private router: Router
  ) { }

  success(message: string, options?: AlertOptions) {
    if(!message) return;
    this.showToast(message, 'Éxito', 'toast-success', options);
  }

  error(message: string, options?: AlertOptions) {
    if(!message) return;
    this.showToast(message, 'Error', 'toast-error', options);
  }

  info(message: string, options?: AlertOptions) {
    if(!message) return;
    this.showToast(message, 'Información', 'toast-info', options);
  }

  warn(message: string, options?: AlertOptions) {
    if(!message) return;
    this.showToast(message, 'Advertencia', 'toast-warning', options);
  }

  private showToast(msg: string, title: string, type: string, options: AlertOptions = {}) {
    
    const toastConfig = { ...this.defaultOptions };
    
    if (options.autoClose === false || (options.autoClose != true && options && options.componente)) {
      toastConfig.disableTimeOut = true;
    }

    const toast = this.toastr.show(msg, title, toastConfig, type);

    if (options && options.componente) {
      toast.toastRef.componentInstance.toastClasses += ' cursor-pointer'; 

      toast.onTap.pipe(take(1)).subscribe(() => {
        this.router.navigate([`/${options.componente}`], { queryParams: options.arguments });
      });
    }

    if (options && options.urlExterna) {
      toast.toastRef.componentInstance.toastClasses += ' cursor-pointer'; 

      toast.onTap.pipe(take(1)).subscribe(() => {
        window.open(options.urlExterna, '_blank');
      });
    }
  }

  clear() {
    this.toastr.clear();
  }
}
